import React, { useCallback, useEffect, useState, useMemo, useRef } from "react";
import MUITable from "../../common/components/mui-table/mui-table";
import _ from "lodash";
import { AlertComponent, BreadcrumbComponent } from "../../common/components";
import { Checkbox } from "@mui/material";
import "./customer-list.scss";
import CustomerFilter from "./customer-filter/customer-filter";
import CustomerFilterOptions from "./customer-filter/customer-filter-options";
import { filterOptions } from "./customer-filter/customer-filter.constant";
import PaginationComponent from "../../common/components/pagination-component/pagination-component";
import { getCustomers } from "../../api/customer";
import { useLogin } from "../../common/hooks/useUser";
import { useSetLoading } from "../../common/hooks/appearance";
import CustomerView from "./customer-view/customer-view";
import { breadcrumbLink } from "./customer-list.constant";
import { useLocation } from "react-router-dom";
import { actionsOptions } from "./customer-filter/customer-filter.constant";
import CustomerActionHandler from "./lead-actions/index";
import { routes } from "../../constants/routes";
import CreateCustomer from './voice-create-customer/create-customer/create-customer';
import { useMediaQuery } from "@mui/material";
import CreateCustomerResponsive from "./voice-create-customer/create-customer-responsive/create-customer-responsive";
import { isValidPhoneNumber } from "../../utils/utils";

interface SortOption {
  sortDirection: string | null;
  sortBy: string | null;
}
const CustomerList: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedCustomers, setSelectedCustomers] = useState<number[]>([]);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [selectedCustomersFilter, setSelectedCustomersFilters] = useState<number[]>([]);
  const [selectedCustomersFilterOptions, setSelectedCustomersFilterOptions] =
    useState<any[]>(filterOptions);
  const [selectedAllCustomers, setSelectedAllCustomers] = useState<any>(null);
  const [selectedCreateCustomers, setSelectedCreateCustomers] = useState<any>(null);
  const [selectedActions, setSelectedActions] = useState<any>(null);
  const [totalRecords, setTotalRecords] = useState<number>(0); // Set an initial value for testing
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(15);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [crumbMappingOption, setCrumbMappingOption] =
    useState<any>(breadcrumbLink);
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState<any>(null);
  const [sortOption, setSortOption] = useState<SortOption>({
    sortDirection: null,
    sortBy: null,
  });
  const [selectedCustomerActionScope, setselectedCustomerActionScope] =
    useState<string>("");
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [isShowCreateCustomer, setIsShowCreateCustomer] = useState<boolean>(false);
  const [isShowCreateCustomerSection, setIsShowCreateCustomerSection] = useState<boolean>(false);
  const [createCustomerInitialValues, setCreateCustomerInitialValues] = useState<any>(null);
  const options = actionsOptions?.map((item) => ({ ...item, isOpen: false }))
  const [menuItems, setMenuItems] = useState<{ value: string, id: number, isOpen: boolean }[]>([...options]);
  const [activeFilters, setActiveFilters] = useState<any>({});
  const [selectedCustomerName, setSelectedCustomerName] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");
  const [isResetSearch, setIsResetSearch] = useState(false);
  const searchRef = useRef<{ clear: () => void }>(null);
  const [disableMassActions, setDisableMassActions] = useState<boolean>(true);
   const isMobile = useMediaQuery("(max-width:600px)");
  const [selectOpen, setSelectOpen] = useState(false);
  const isSearchTriggered = useRef(false);
  const [viewTaskvalue, setViewTaskvalue] = useState({
    open: false,
    taskId: null,
  });
  const [viewMeetingvalue, setViewMeetingvalue] = useState({
    open: false,
    meetingId: null,
  });
  const [viewCallValue, setViewCallValue] = useState({
    open: false,
    callId: null,
  });

  const handleSearch = useCallback(
    _.debounce((text: string) => {
      setSearchText(text);
      isSearchTriggered.current = true;
      setCurrentPage(1);
      if (text === "") {
        setIsResetSearch(true);
        setTimeout(() => setIsResetSearch(false), 100);
      }
    }, 500),
    []
  );

  const resetSearch = () => {
    setSearchText("");
    if (searchRef.current) {
      searchRef.current.clear();
    }
    // handleSearch("");
  };

  const userDetails = useLogin();
  const leadOwner =
    userDetails?.userDetails?.firstName +
    " " +
    userDetails?.userDetails?.lastName;

  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      setAlertMessage(location.state.message);
      setAlertType(location.state.type);
      setAlertOpen(true);
    }
    window.history.replaceState({}, document.title);
  }, [location.state]);

  const fetchCustomers = async (page = 1, search: string = "", filters: any = {}) => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      let params: any = {
        limit: pageSize,
        offset: offset,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      if (sortOption?.sortBy) {
        params = { ...params, ...sortOption };
      }
      if (search) {
        params.searchText = search;
      }
      if (filters?.email) {
        params.email = filters.email;
      }
      if (filters?.firstName) {
        params.firstName = filters.firstName;
      }
      if (filters?.lastName) {
        params.lastName = filters.lastName;
      }
      if (filters?.company) {
        params.company = filters.company;
      }
      if (filters?.leadSource) {
        params.leadSource = filters.leadSource;
      }
      if (filters?.dateOfBirthFrom && filters.dateOfBirthTo) {
        // if (filters.dateOfBirthFrom.isSame(filters.dateOfBirthTo)) {
          params.dobStart = filters.dateOfBirthFrom.startOf('day');
          params.dobEnd = filters.dateOfBirthTo.endOf('day');
        // } else {
        //   params.dateOfBirthFrom = filters.dateOfBirthFrom;
        //   params.dateOfBirthTo = filters.dateOfBirthTo
        // }
      }
      if (filters?.customerOwnerIds?.length > 0) {
        params.customerOwner = filters.customerOwnerIds.map(Number);
      }
      const response = await getCustomers(params, "Customer Profile");
      setData(response?.data.data.customersList);
      setTotalRecords(response?.data.data.totalRecords);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(error?.response?.data?.message || "Failed to fetch Customers");
      setAlertType("error");
      setAlertOpen(true);
      setError("Failed to fetch customers list");
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!viewOpen) {
      const pageToUse = isSearchTriggered.current ? 1 : currentPage;
      fetchCustomers(pageToUse, searchText, activeFilters);
      isSearchTriggered.current = false;
    }
  }, [currentPage, searchText, isOpen, sortOption, viewOpen, activeFilters]);
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };
  const [selectedCustomersMap, setSelectedCustomersMap] = useState<{
    [page: number]: number[];
  }>({});
  const isAllSelected =
  Array.isArray(data) &&
  data.length > 0 &&
  selectedCustomersMap[currentPage]?.length === data.length;
  const isIndeterminate =
    selectedCustomersMap[currentPage]?.length > 0 &&
    selectedCustomersMap[currentPage]?.length < data.length;
  const handleSelectAll = () => {
    setSelectedCustomersMap((prev) => {
       const currentPageCustomers = Array.isArray(data) ? data.map((item) => item.id) : [];
      const selectedCustomersOnPage = prev[currentPage] || [];

      if (selectedCustomersOnPage.length > 0) {
        return { ...prev, [currentPage]: [] };
      }
      return { ...prev, [currentPage]: currentPageCustomers };
    });
  };

  const handleCheckboxChange = (id: number) => {
    setSelectedCustomersMap((prev) => {
      const prevSelected = prev[currentPage] || [];
      const newSelected = prevSelected.includes(id)
        ? prevSelected.filter((leadId) => leadId !== id)
        : [...prevSelected, id];

      return {
        ...prev,
        [currentPage]: newSelected,
      };
    });
  };

  const headers = [
    {
      key: "select",
      label: (
        <Checkbox
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={handleSelectAll}
        />
      ),
    },
    { key: "leadName", label: "Customer Name", isSortable: true },
    { key: "accountName", label: "Company", isSortable: true },
    { key: "email", label: "Email", isSortable: true },
    { key: "phone", label: "Phone Number", isSortable: true },
    { key: "leadOwner", label: "Customer Owner", isSortable: true },
  ];

  const mapColumnNameToField = (columnName: string): string => {
    const mapping: Record<string, string> = {
      leadName: "first_name",
      accountName:"company",
      email: "primary_email_address",
      phone: "primary_phone_number",
      leadSource: "lead_source",
      leadOwner: "customer_owner",
    };

    return mapping[columnName] || columnName;
  };
  const handleSort = (column: string, sortType: string) => {
    let sortValues: SortOption = { sortBy: null, sortDirection: null };
    if (sortType !== "Unsort") {
      const mappedField = mapColumnNameToField(column);
      sortValues = { sortBy: mappedField, sortDirection: sortType };
    }
    setCurrentPage(1);
    setSortOption(sortValues);
  };


  const handleViewClick = async (customerId: number, customerName: string) => {
    setSelectedCustomerId(customerId);
    setSelectedCustomerName(customerName);

    setCrumbMappingOption([
      {
        label: "Customer Management",
        link: routes.CUSTOMERLIST,
        handleClick: (event: any) => {
          event.preventDefault();
          setViewTaskvalue({ open: false, taskId: null });
          setViewMeetingvalue({ open: false, meetingId: null });
          setViewCallValue({ open: false, callId: null });
          setCrumbMappingOption(breadcrumbLink);
          setViewOpen(false);
          setCurrentPage(1);
        },
      },
      {
        label: "Customer Profile",
        link: routes.CUSTOMERLIST,
        handleClick: (event: any) => {
          event.preventDefault();
          setViewTaskvalue({ open: false, taskId: null });
          setViewMeetingvalue({ open: false, meetingId: null });
          setViewCallValue({ open: false, callId: null });
          setCrumbMappingOption(breadcrumbLink);
          setViewOpen(false);
          setCurrentPage(1);
        },
      },
      { label: customerName, link: "" },
    ]);

    setViewOpen(true);
  };
  const handleCustomerNameUpdate = (newName: string) => {
    setSelectedCustomerName(newName);
    setCrumbMappingOption((prev: any) => {
      const updated = [...prev];
      updated[2] = { ...updated[2], label: newName };
      return updated;
    });
  };

  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const lastName = item?.last_name?.trim();
    const middleName = item?.middle_name ? item?.middle_name?.trim() : "";

    const fullName =
      firstName && lastName
        ? `${firstName} ${middleName} ${lastName}`
        : firstName
          ? firstName : middleName
            ? middleName
            : lastName
              ? lastName
              : "-";
    return fullName;
  }

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item) => {
        const firstName = item.first_name?.trim();
        const lastName = item.last_name?.trim();
        const middleName = item?.middle_name ? item?.middle_name?.trim() : "";
        const fullName =
          firstName && lastName
            ? `${firstName ? `${firstName} `:""}${middleName ? `${middleName} `:""}${lastName}`
            : firstName || middleName || lastName || "-";

        const leadName = fullName;
        const leadOwnerName = fetchFullName(item?.customerOwner)
        return {
          id: item.id,
          accountName: item.company || "-",
          leadName: leadName,
          email: item.primary_email_address || "-",
          phone: isValidPhoneNumber(item.primary_phone_number)
            ? item.primary_phone_number
            : "-",
          leadSource: item.lead_source || "-",
          leadOwner: leadOwnerName,
        };
      });
    }
    return [];
  }, [data, leadOwner]);

  const handleActionTrigger = (action: string) => {
    setMenuItems((prevItems) =>
      prevItems.map((item) =>
        item.value === action ? { ...item, isOpen: !item?.isOpen } : item
      )
    );
  };

  const checkDisableOfActionScope = () => {
    const disableScope = [{ "All Customers": true }, { "Selected Customers": true }];
    if (data?.length >= 1) disableScope[0]["All Customers"] = false;
    if (Object.values(selectedCustomersMap)?.flat(Infinity).length >= 1) disableScope[1]["Selected Customers"] = false;
    return disableScope;
  };

  useEffect(() => {
    if (Object.values(selectedCustomersMap)?.flat(Infinity).length >= 1) {
      setDisableMassActions(false)
    }
    else if (Object.values(selectedCustomersMap)?.flat(Infinity).length === 0) {
      setDisableMassActions(true)
    }
  }, [selectedCustomersMap])

  const handleMassActionMenuClose = () => {
    if (setSelectOpen) setSelectOpen(false)
      setSelectedActions(null);
  }
  const appliedFilterCount = useMemo(() => {
    let count = 0;
    const dateFilterActive = activeFilters.createdTimeStart || activeFilters.createdTimeEnd;
    const runFilterActive = activeFilters.lastActivityTimeStart || activeFilters.lastActivityTimeEnd;

    const otherFilters = { ...activeFilters };
    delete otherFilters.createdTimeStart;
    delete otherFilters.createdTimeEnd;
    delete otherFilters.lastActivityTimeStart;
    delete otherFilters.lastActivityTimeEnd;


    const otherActiveFilters = Object.values(otherFilters).filter((val) => {
      if (val === undefined || val === "" || val === null) return false;
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === "object") {
        return Object.values(val).some(
          (v) => v !== "" && v !== undefined && v !== null
        );
      }
      return true;
    }).length;
    if (dateFilterActive) {
      count += 1;
    }
    if (runFilterActive) {
      count += 1;
    }

    count += otherActiveFilters;

    return count;
  }, [activeFilters]);
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  const [showImportModal, setShowImportModal] = useState(false);

  const createUpdateCustomerList = () => {
    fetchCustomers();
    setSearchText("");
    setActiveFilters({});
    setSelectedCustomersMap({});
    setCurrentPage(1);
    setSelectedCustomers([]);
    setSelectedCustomersFilters([]);
    setSelectedCustomersFilterOptions(filterOptions);
    setSelectedAllCustomers(null);
    setSelectedCreateCustomers(null);
    setSelectedActions(null);
    setSortOption({ sortBy: null, sortDirection: null });

  }
  const noResultText = useMemo(() => {
    if (loading) {
      return "Loading Customers...";
    }
    const hasActiveFilters = Object.keys(activeFilters).length > 0 && Object.values(activeFilters).some(v => v && (Array.isArray(v) ? v.length > 0 : v !== ""));
    if (hasActiveFilters) {
      return "No results found matching your filter criteria.";
    }
    if (searchText) {
      return "No customers found matching your search criteria";
    }
    return "No customers found";
  }, [loading, searchText]);

  return (
    <>
      {isShowCreateCustomerSection ? (isMobile ? (
        <CreateCustomerResponsive createCustomerInitialValues={createCustomerInitialValues} setCreateCustomerInitialValues={setCreateCustomerInitialValues} setIsShowCreateCustomerSection={setIsShowCreateCustomerSection} updateCustomerList={createUpdateCustomerList} setAlertMessage={setAlertMessage}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen} />):(
        <CreateCustomer createCustomerInitialValues={createCustomerInitialValues} setCreateCustomerInitialValues={setCreateCustomerInitialValues} setIsShowCreateCustomerSection={setIsShowCreateCustomerSection} updateCustomerList={createUpdateCustomerList} setAlertMessage={setAlertMessage}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen} />)):(
        <div className="customerlist-wrapper">
          {/* Breadcrumb Section */}
          <div className="breadcrumb-wrapper">
            <BreadcrumbComponent breadcrumbLink={crumbMappingOption} />
          </div>

          <div style={{ display: !viewOpen ? "block" : "none" }}>
            <div>
              <CustomerFilter
                isOpenFilter={isOpenFilter}
                setIsOpenFilter={setIsOpenFilter}
                selectedCustomersFilter={appliedFilterCount}
                selectedAllCustomers={selectedAllCustomers}
                setSelectedAllCustomers={setSelectedAllCustomers}
                selectedCreateCustomers={selectedCreateCustomers}
                setSelectedCreateCustomers={setSelectedCreateCustomers}
                selectedActions={selectedActions}
                setSelectedActions={setSelectedActions}
                onSearch={handleSearch}
                searchRef={searchRef}
                isResetSearch={isResetSearch}
                resetSearch={resetSearch}
                disableSelectedCustomers={checkDisableOfActionScope()}
                handleActionTrigger={handleActionTrigger}
                setIsShowCreateCustomer={setIsShowCreateCustomer}
                isShowCreateCustomer={isShowCreateCustomer}
                disabled={disableMassActions}
                selectOpen={selectOpen}
                setSelectOpen={setSelectOpen}
                totalCustomers={data?.length || 0}
                showImportModal={showImportModal}
                setShowImportModal={setShowImportModal}
                isShowCreateCustomerSection={isShowCreateCustomerSection}
                setIsShowCreateCustomerSection={setIsShowCreateCustomerSection}
                fetchCustomers={() => { setIsResetSearch(!isResetSearch); setSearchText(""); fetchCustomers(currentPage) }}
              />
            </div>
            {/* Table Section */}
            <div className="customer-list-table-filter">
              <div
                className="customer-list-table"
                style={isOpenFilter ? { width: "80%" } : {}}
              >
                <MUITable
                  headers={headers}
                  data={formattedData.map((item) => ({
                    key: item.id,
                    select: (
                      <Checkbox
                        checked={
                          selectedCustomersMap[currentPage]?.includes(item.id) ||
                          false
                        }
                        onClick={(event) => event.stopPropagation()}
                        onChange={() => handleCheckboxChange(item.id)}
                      />
                    ),
                    leadName: item.leadName,
                    accountName: item.accountName,
                    email: item.email,
                    phone: item.phone,
                    leadSource: item.leadSource,
                    leadOwner: item.leadOwner,
                  }))}
                  onSort={handleSort}
                  noResultsTxt={noResultText}
                  onRowClick={(rowData: any) => handleViewClick(rowData.key, rowData.leadName)}
                />
              </div>
              <div style={{ display: isOpenFilter ? "block" : "none" }} className="customer-list-filter">
                <CustomerFilterOptions
                  isOpenFilter={isOpenFilter}
                  setIsOpenFilter={setIsOpenFilter}
                  selectedCustomersFilter={selectedCustomersFilter}
                  setSelectedCustomersFilters={setSelectedCustomersFilters}
                  selectedCustomersFilterOptions={selectedCustomersFilterOptions}
                  setAlertMessage={setAlertMessage}
                  setAlertType={setAlertType}
                  setAlertOpen={setAlertOpen}
                  setSelectedCustomersFilterOptions={
                    setSelectedCustomersFilterOptions
                  }
                  onApplyFilters={(filters: any) => {
                    setCurrentPage(1);
                    setActiveFilters(filters);
                  }}
                  activeFilters={activeFilters}
                />
              </div>
            </div>
            {totalRecords && totalRecords > 0 ? (
              <div className="leads-pagination-container"
                style={{
                  pointerEvents: showImportModal ? 'none' : 'auto',
                  opacity: showImportModal ? 0.5 : 1,
                }}
              >
                <PaginationComponent
                  totalRecords={totalRecords}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          {!viewOpen ? (""
          ) : (
            <CustomerView 
            setLoading={setLoading} 
            selectedCustomerId={selectedCustomerId}
             onCustomerNameUpdate={handleCustomerNameUpdate}
             setViewTaskvalue={setViewTaskvalue}
             viewTaskvalue={viewTaskvalue}
             setViewMeetingvalue={setViewMeetingvalue}
             viewMeetingvalue={viewMeetingvalue} 
             setCrumbMappingOption={setCrumbMappingOption}
             setViewCallValue={setViewCallValue}
             viewCallValue={viewCallValue}
              />
          )}
          <CustomerActionHandler
            selectedCustomersMap={selectedCustomersMap}
            setSelectedCustomersMap={setSelectedCustomersMap}
            selectedActions={selectedActions}
            setSelectedActions={setSelectedActions}
            menuItems={menuItems}
            setMenuItems={setMenuItems}
            fetchCustomers={() => {
             if (searchText) resetSearch();
             if (currentPage === 1) fetchCustomers()
             else setCurrentPage(1);
            }}
            selectedCustomerActionScope={selectedCustomerActionScope}
            setselectedCustomerActionScope={setselectedCustomerActionScope}
            totalRecords={totalRecords}
            handleMassActionMenuClose={handleMassActionMenuClose}
            leadsData={data}
          />
        </div>)}
      <AlertComponent
        message={alertMessage}
        type={alertType ?? "info"}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default CustomerList;
